import { useContext, useEffect } from 'react'

import fimAberturaKids from 'assets/images/fimAberturaKids.png'
import { Gray, Orange } from 'assets/styled-component/variables'
import { PageContainer, ButtonWrapper, Text, Button, Spacing } from 'components'
import { Icons, InterLogo } from 'components/elements/Icons'
import { useHistory } from 'react-router-dom'
import { RoutesEnum } from 'enums/routes.enum'
import { sendToNewRelic } from 'services'
import { IFichaCadastralCtx } from 'interfaces/fichaCadastral.interface'
import { FichaCadastralCtx } from 'App'
import { sendDataNative, TSendDataNative } from 'components/hooks/useFetchNative'

import { Icon } from '@inter/inter-ui'

import { DivGoToDigitalAccount, DivTextGoToDigitalAccount } from './style'

const FimAberturaKids = () => {
  const history = useHistory()

  const { hsfc }: IFichaCadastralCtx = useContext<IFichaCadastralCtx>(FichaCadastralCtx)
  const hsfcValue = (): string => hsfc || (sessionStorage.getItem('hsfc') as string)
  const irParaFimOnboard = () => {
    sendToNewRelic('POS_ABERTURA', `[CLIK] - Finalizar`, {
      FICHA_CADASTRAL: hsfcValue(),
      PRODUCT: 'CONTA_DIGITAL',
      MINOR: 'KIDS',
    })

    history.push(RoutesEnum.FIM_ONBOARDING)
  }

  const irParaAberturaPf = () => {
    const callApi: TSendDataNative = {
      method: 'NEWONBOARDING',
    }
    sendDataNative(callApi)

    sendToNewRelic('POS_ABERTURA', `[CLIK] - Abrir conta digital`, {
      FICHA_CADASTRAL: hsfcValue(),
      PRODUCT: 'CONTA_DIGITAL',
      MINOR: 'KIDS',
    })
  }

  useEffect(() => {
    sendToNewRelic('POS_ABERTURA', 'FIM_ABERTURA_KIDS', {
      FICHA_CADASTRAL: hsfcValue(),
      PRODUCT: 'CONTA_DIGITAL',
      MINOR: 'KIDS',
    })
  }, [])

  return (
    <PageContainer>
      <img
        src={fimAberturaKids}
        alt="Preencher todas as informações!"
        style={{ margin: '0 -24px', width: 'calc(100% + 48px)' }}
      />
      <Spacing mt="xs" mb="xs">
        <Text variant="headline-h1">Agora é só aguardar!</Text>
      </Spacing>

      <Text variant="body-3" as="p">
        Já recebemos seus documentos e estamos analisando sua solicitação. Você receberá o nosso
        retorno em até 3 dias úteis.
      </Text>

      <Text variant="body-3" as="p">
        Aproveite para abrir sua conta digital e acompanhe seu pequeno aqui no Inter!
      </Text>

      <DivGoToDigitalAccount
        onClick={irParaAberturaPf}
        onKeyPress={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            irParaAberturaPf()
          }
        }}
        role="button"
        tabIndex={0}
      >
        <DivTextGoToDigitalAccount>
          <Icons variant={InterLogo} color={Gray[500]} />
          <Text variant="body-3" bold>
            Abrir conta digital
          </Text>
        </DivTextGoToDigitalAccount>

        <Icon name="arrow-right" size={24} color={Orange[500]} />
      </DivGoToDigitalAccount>

      <ButtonWrapper>
        <Button id="submit" onClick={irParaFimOnboard}>
          Finalizar
        </Button>
      </ButtonWrapper>
    </PageContainer>
  )
}

export default FimAberturaKids
